import { Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
import DashboardLayout from 'src/layouts/dashboard';
import { LoadingScreen } from 'src/components/loading-screen';
const BillingPage = lazy(() => import('src/pages/billing'));
const TransactionsPage = lazy(() => import('src/pages/billing/transactions'));
const OrgBillingDetailsPage = lazy(() => import('src/pages/billing/org-billing-details'));
const ViewInvoicePage = lazy(() => import('src/pages/billing/view-invoice'));
const EditInvoicePage = lazy(() => import('src/pages/billing/edit-invoice'));
const TaskBillsPage = lazy(() => import('src/pages/billing/task-bill-runs'));
const TaskBillViewPage = lazy(() => import('src/pages/billing/task-bill-run-view'));
const PaymentRemindersPage = lazy(() => import('src/pages/billing/payment-reminders'));
const RedirectPage = lazy(() => import('src/pages/billing/empty-page'));

export const billingRoutes = [
  {
    path: 'billing',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <BillingPage />, index: true },
      { element: <TransactionsPage />, path: 'transactions' },
      { element: <OrgBillingDetailsPage />, path: 'org-billing-details' },
      { element: <TaskBillsPage />, path: 'task-bill-runs' },
      { element: <TaskBillViewPage />, path: 'task-bill-runs/:taskBillRunId' },
      { element: <PaymentRemindersPage />, path: 'payment-reminders' },
      { element: <RedirectPage />, path: 'redirect-page' },
      { path: ':invoiceId', element: <ViewInvoicePage /> },
      { path: ':invoiceId/edit', element: <EditInvoicePage /> },
    ],
  },
];
